import { PublicLayout } from "@/components/PublicLayout";

const content = {
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Acceptance of Terms", "By accessing or using AI TECHNOLOGY, you agree to be bound by these Terms & Conditions. If you do not agree, do not use the platform."],
      ["Eligibility", "You must be of legal age in your jurisdiction and legally permitted to use digital asset services. You are responsible for compliance with your local laws."],
      ["No Guaranteed Returns", "AI TECHNOLOGY does not guarantee any profit, income, daily return or withdrawal. Any percentages displayed are variable and non-guaranteed. Digital assets involve significant risk of loss."],
      ["Deposits & Withdrawals", "All deposits are subject to manual review and approval. Withdrawals are processed only after review. Balances are managed server-side and cannot be altered by users."],
      ["Prohibited Conduct", "You may not attempt to manipulate balances, submit fraudulent transactions, or misuse the referral program. Violations may result in account suspension."],
      ["Limitation of Liability", "AI TECHNOLOGY is provided 'as is'. We are not liable for losses arising from market volatility, network issues, or user error."],
      ["Company Shares", "Company shares are offered at a platform-set price per share and in limited quantity. Share purchases and deposits for shares are subject to manual verification, KYC/AML requirements and applicable securities and digital-asset regulations in the relevant jurisdictions. Shares are confirmed only after approval; pending requests may be rejected and refunded. Share ownership does not carry guaranteed profit, dividends, appreciation or buy-back."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Information We Collect", "We collect your name, email, mobile number, and any verification documents you submit. Transaction data is recorded for accounting and compliance."],
      ["How We Use Data", "Your data is used to operate your account, process deposits and withdrawals, prevent fraud, and comply with applicable obligations."],
      ["Document Security", "Verification documents and payment screenshots are stored securely and are only accessible to you and authorized reviewers."],
      ["Data Sharing", "We do not sell your personal data. Data may be shared with service providers strictly to operate the platform."],
      ["Your Rights", "You may request access to or correction of your personal data through your profile or by contacting support."],
    ],
  },
  risk: {
    title: "Risk Disclosure",
    sections: [
      ["Significant Risk", "Digital assets are highly volatile and involve significant risk. You may lose some or all of the value you deposit."],
      ["No Guarantees", "AI TECHNOLOGY does not offer guaranteed profit, guaranteed daily returns, risk-free investment, guaranteed income or guaranteed withdrawals. Any earnings percentages are variable and non-guaranteed."],
      ["Market Volatility", "The value of digital assets can change rapidly due to market conditions beyond our control."],
      ["Informed Participation", "Only participate with funds you can afford to lose. Review all applicable terms and seek independent advice if needed."],
      ["No Regulatory Claims", "AI TECHNOLOGY does not claim any license, registration, government approval, partnership or regulatory status unless explicitly and verifiably stated."],
      ["Company Shares Risk", "Purchasing company shares involves risk, including the potential loss of the full amount paid. There is no guaranteed appreciation, dividend, liquidity or resale market. Share price and availability are set by the platform and may change. Issuance is subject to verification and applicable regulations."],
    ],
  },
  withdrawal: {
    title: "Withdrawal Policy",
    sections: [
      ["Request & Review", "All withdrawal requests are subject to review before processing. Funds are never sent automatically."],
      ["Available Balance", "Withdrawals cannot exceed your available balance. Balance is deducted only upon approval, atomically and server-side."],
      ["Networks", "Withdrawals are supported on TRC20 and BEP20. Ensure your wallet address matches the selected network."],
      ["Rejections", "Requests may be rejected for invalid details or suspected misuse. A reason is always provided."],
    ],
  },
  kyc: {
    title: "KYC / AML Policy",
    sections: [
      ["Verification", "We may require identity verification (KYC) to enhance account security and comply with applicable obligations."],
      ["Documents", "You may be asked to provide a government ID and a selfie. Documents are stored securely with restricted access."],
      ["Anti-Money Laundering", "We monitor for suspicious activity and may suspend accounts involved in prohibited conduct."],
      ["Data Retention", "Verification data is retained only as long as necessary to operate the platform and meet obligations."],
    ],
  },
};

export default function Legal({ page }) {
  const data = content[page] || content.terms;
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 pt-16 pb-20">
        <p className="label-eyebrow text-xs font-mono uppercase tracking-[0.25em] text-cyan-400 mb-3">Legal</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-8">{data.title}</h1>
        <div className="space-y-8">
          {data.sections.map(([h, b], i) => (
            <div key={i}>
              <h2 className="font-heading text-lg text-white mb-2">{i + 1}. {h}</h2>
              <p className="text-slate-400 leading-relaxed text-sm">{b}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-600 mt-12">Last updated: {new Date().toLocaleDateString()}</p>
      </section>
    </PublicLayout>
  );
}
